import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SingleFriendStatusComponent } from './singleFriendStatus.component';
import { ButtonModule } from '@app/components/button/button.module';
import { TranslateModule } from '@ngx-translate/core';
import { PlIconModule } from '@app/icon-library/lib/pl-icon.module';
import { ReactiveFormsModule } from '@angular/forms';
import { PlInputModule } from '@app/components/pl-input/pl-input.module';

@NgModule({
  imports: [CommonModule, ButtonModule, TranslateModule, PlIconModule, ReactiveFormsModule, PlInputModule],
  declarations: [SingleFriendStatusComponent],
  exports: [SingleFriendStatusComponent],
})
export class SingleFriendStatusModule {}
